module.exports = __webpack_public_path__ + "img/科技框.9b8579f8.png";